module.exports = __webpack_public_path__ + "img/pen-ruler.1529ad11.svg";